module.exports = __webpack_public_path__ + "static/media/workEthic-red.5ce3fb8c.svg";